import { privateAxios, publicAxios } from "../../../config/apiConfig";
import {
  GET_ALL_REVIEW_BY_PRODUCT_SUCCESS,
  GET_ALL_REVIEW_BY_PRODUCT_REQUEST,
  GET_ALL_REVIEW_BY_PRODUCT_FAILURE,
  CREATE_REVIEW_REQUEST,
  CREATE_REVIEW_SUCCESS,
  CREATE_REVIEW_FAILURE,
  DELETE_REVIEW_REQUEST,
  DELETE_REVIEW_SUCCESS,
  DELETE_REVIEW_FAILURE,
} from "./ActionType";

export const getAllReview = (productId) => async (dispatch) => {
  dispatch({ type: GET_ALL_REVIEW_BY_PRODUCT_REQUEST });
  try {
    const { data } = await publicAxios.get(`review/product/${productId}`);
    dispatch({ type: GET_ALL_REVIEW_BY_PRODUCT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_REVIEW_BY_PRODUCT_FAILURE, payload: error.message });
  }
};

export const createReview = (productId, review) => async (dispatch) => {
  dispatch({ type: CREATE_REVIEW_REQUEST });
  try {
    const { data } = await privateAxios.post(`user/review/product/${productId}`, review);
    dispatch(getAllReview(productId))
    dispatch({ type: CREATE_REVIEW_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: CREATE_REVIEW_FAILURE, payload: error.message });
  }
};

export const deleteReview = (reviewId) => async (dispatch) => {
  dispatch({ type: DELETE_REVIEW_REQUEST });
  try {
    const { data } = await privateAxios.delete(`user/review/${reviewId}`);
    dispatch({ type: DELETE_REVIEW_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: DELETE_REVIEW_FAILURE, payload: error.message });
  }
};
